/**
 * Feinschliff fuer die Mobilansicht.
 *   1. Die Punkte der Ankuendigungsleiste laufen einer nach dem anderen durch.
 * Greift nur unterhalb von 768 Pixeln; darueber raeumt das Skript seine
 * Spuren wieder weg.
 */
(function () {
	var schmal = window.matchMedia('(max-width: 767px)');
	var takt = null;

	/* ---------------- Ankuendigungsleiste ---------------- */

	function leisteStarten() {
		var leiste = document.querySelector('.announcement-bar--inner.announcement-bar--static');
		if (!leiste) return;
		var punkte = Array.prototype.slice.call(leiste.querySelectorAll('.announcement-bar--item'));
		if (punkte.length < 2) return;

		leiste.classList.add('rotiert');
		var i = 0;
		punkte.forEach(function (p, n) {
			p.classList.toggle('ist-sichtbar', n === 0);
		});

		// setTimeout statt requestAnimationFrame: rAF wird in Fenstern im
		// Hintergrund gedrosselt, die Leiste bliebe dann stehen.
		function weiter() {
			punkte[i].classList.remove('ist-sichtbar');
			i = (i + 1) % punkte.length;
			punkte[i].classList.add('ist-sichtbar');
			takt = window.setTimeout(weiter, 3500);
		}
		takt = window.setTimeout(weiter, 3500);
	}

	function leisteStoppen() {
		window.clearTimeout(takt);
		takt = null;
		var leiste = document.querySelector('.announcement-bar--inner.announcement-bar--static');
		if (!leiste) return;
		leiste.classList.remove('rotiert');
		leiste.querySelectorAll('.announcement-bar--item').forEach(function (p) {
			p.classList.remove('ist-sichtbar');
		});
	}

	/* ---------------- Schalter ---------------- */

	function anpassen() {
		if (schmal.matches) {
			if (!takt) leisteStarten();
		} else {
			leisteStoppen();
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', anpassen);
	} else {
		anpassen();
	}
	// Die Folien werden nachtraeglich aufgebaut, deshalb ein zweiter Anlauf.
	window.setTimeout(anpassen, 600);
	window.addEventListener('resize', function () {
		window.clearTimeout(window.__mobilFeinschliffTimer);
		window.__mobilFeinschliffTimer = window.setTimeout(anpassen, 200);
	});
})();
